import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { currentBskProperty, infosMail, prepareFileName, setInfosMail } from '@core/_utils/tools.utils';
import { EditorService } from '@service/editor.service';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from '@service/apiv6.service';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { indexInputMode } from '@documalis/_const/const';
import { AddFileService } from '@service/addfile.service';
import { LayoutService } from '../../layout/service/app.layout.service';

@Component({
    selector: 'basketnewdoc',
    templateUrl: 'basketnewdoc.component.html',
    styleUrls: ['basketnewdoc.component.scss'],
})
export class BasketNewDocComponent {
    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onSelectFilter: EventEmitter<any> = new EventEmitter();

    @Input()
    public bsk;

    @Input() public baseRoot = '';
    @Input() public storagePath = '';
    @Input() public usePreProcess;
    @Input() public preProcessName;
    @Input() public parameterList;
    @Input() public priority = '5';

    public error = false;
    public errorMessage = '';
    public loadingMessage = '';
    public listRequest: any;
    public currentBskProperty: currentBskProperty;
    public bskVariableList = [];
    public isLoading: boolean = true;
    public isDesktop: boolean = false;
    public currentInfosMail: any;
    public categoryList = [];
    public categoryOptions = [];
    public modeleList = [];
    public pathImg: string;
    public pathPdf: string;
    public showThumbImg = false;
    public showPdf = false;
    public currentVarList: any[];
    public enterVariable: boolean = false;
    public binaryId: string;
    private modeleInfo: any;
    private blobPdf : Blob;
    public model: any;
    public category: any;

    constructor(private translate: TranslateService,
        protected _messageService: MessagesService,
        public editorService: EditorService,
        private api: ApiV6Service,
        private addFileService: AddFileService,
        private main: LayoutService,) {
        this.loadingMessage = this.translate.instant('Load_Data');
        this.currentInfosMail = new Object();
        this.currentVarList = new Array();
        this.isDesktop = this.main.isDesktop();
    }

    public ngOnInit() {
        this.currentBskProperty = {
            bsk_docdate: '',
            bsk_docstatus: '',
            bsk_wkfid: '',
            bsk_mailaction: '',
            bsk_maillimit: '',
            bsk_mailurgent: '',
            bsk_mailconf: '',
        };        
        this.binaryId = '';
        this.model = '';
        this.category = '';
    }

    ngOnChanges() {
        if (this.bsk) {
            this.getVarBsk(this.bsk.bskType, this.bsk.bskName);
        }
    }
    
    private async getVarBsk(aBskType, aBskName) {
        this.isLoading = true;
        await this.execgetBskVariableList(aBskType, aBskName);
        this.currentInfosMail = setInfosMail(true, '', this.translate);
        this.isLoading = false;
    }

    private async execgetBskVariableList(aBskType, aBskName) {
        let wRes: any;
        this.bskVariableList = [];
        try {
            wRes = await lastValueFrom(this.getVarTrsBsk(aBskType, aBskName));      
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant(error.error.CodeMessage));
            return;
        }
        if (wRes.getCategoryModel.CategoryList.Category.length === 0) {
            this._messageService.addWarn(this.translate.instant('No_Category'));
            this.close();
            return;
        }
        this.categoryList = wRes.getCategoryModel.CategoryList.Category;
        this.categoryOptions = this.getCateoryList(this.categoryList);
        this.editorService.setCustomEditorList(wRes.getEditorList.CustomEditorList);
        this.editorService.setMode(true);
        this.editorService.variableListService.parseService.setBasketName(aBskName);
        this.bskVariableList = JSON.parse(
            JSON.stringify(
                this.editorService.formatVarList(this.editorService.variableListService.execParse(wRes.getBskVariableList))
            )
        );
        this.enterVariable = this.addFileService.getEnterVariable(this.bskVariableList);

        if (aBskType === 'btMail') {
            this.enterVariable = true;
        } else {
            if (this.bsk.bskIndexInputMode === indexInputMode[1]) {
                this.enterVariable = false;
            }
        }
        this.currentInfosMail = setInfosMail(true, '', this.translate);    
    }

    private getVarTrsBsk(aBskType, aBskName) {
        const wDataRequest = { 
            baskettype: aBskType, basketname: aBskName };
        return forkJoin([
            this.api.getCustomEditorlist(),
            this.api.execUrlAction('getbskvariablelist', wDataRequest),
            this.api.execUrlAction('getcategorymodel', ''),
        ]).pipe(
            map(([getEditorList, getBskVariableList, getCategoryModel]) => {
                return { getEditorList, getBskVariableList, getCategoryModel };
            })
        );
    }

    private getCateoryList(aCategoryList) {
        let wCateoryList = [];
        for (const item of aCategoryList) {
            wCateoryList.push({
                name: item.category,
                code: item.category,
            })
        }
        return wCateoryList;
    }

    private getModeleList(aModeleList) {
        let wModeleList = [];
        for (const item of this.categoryList) {
            if (item.category == aModeleList) {
                for (const elem of item.ModelDocList) {
                    wModeleList.push({
                        name: elem.Information.Name,
                        code: elem.Information.Name,
                        thumb: elem.Document.Thumbnail,
                        document: elem.Document.Document,
                        documentName: elem.Document.DocumentName
                    })
                }                
            }
        }
        return wModeleList;
    }

    public close() {
        this.onClose.emit();
    }

    public onChangeCateg($event) {
        this.binaryId = '';
        this.modeleList = this.getModeleList($event.value.code);        
    }  
    
    public async onChangeModele($event) {
        let wRes: any;
        let wRequest: any = {};
        this.binaryId = $event.value.thumb;
        this.modeleInfo = $event.value;
        try {
            wRequest = {
                BinaryID: this.binaryId
            };
            this.showThumbImg = false;
            this.showPdf = false;
            this.pathPdf = '';
            wRes = await lastValueFrom(this.api.execPostUrlFileAction('getbinary', wRequest));      
            this.pathImg = window.URL.createObjectURL(wRes);
            this.showThumbImg = true;
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private verfyModel() {
        if (this.binaryId === '') {
            this._messageService.addWarnNoStick(this.translate.instant('Modele_Empty'));
            return false;
        }
        return true;
    }

    public async onClickPreview() {
        let wVarList = [];
        let wInfosMail: infosMail;
        let wRes: any;
        let wRequest: any = {};
        let wjson = '';   
        if (this.verfyModel() === false) {
            return;
        }
        try {
            wInfosMail = setInfosMail(true, '', this.translate);
            wInfosMail = this.addFileService.setInfosMail(this.currentInfosMail, this.translate);
            this.editorService.setChangeDyn(false);
            this.editorService.setMode(true);
            wVarList = JSON.parse(JSON.stringify(this.bskVariableList));
            this.currentVarList = this.editorService.setValueForUpdate(wVarList);
            if (this.enterVariable === false) {
                this.updateDocAddList(this.currentVarList);
            }
            wjson = this.addFileService.prepareVarList(this.currentVarList, this.editorService);
            
            wRequest = {
                variable : wjson,
                infosMail: wInfosMail,
                modeleInfo: this.modeleInfo
            }
            wRes = await lastValueFrom(this.api.execPostUrlFileAction('getpreviewdoc', wRequest));  
            this.showThumbImg = false;
            this.showPdf = true;
            this.pathImg = '';
            this.blobPdf = new Blob([wRes]);
            this.pathPdf = window.URL.createObjectURL(wRes);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant("Work_KO"));
        }
    }

    public async onClickSend() {
        let wVarList = [];
        let wRes: any;
        let wFileName = '';
        if (this.verfyModel() === false) {
            return;
        }
        try {
            wFileName = prepareFileName(this.modeleInfo.documentName, 64, false);
            this.editorService.setChangeDyn(false);
            this.editorService.setMode(true);
            wVarList = JSON.parse(JSON.stringify(this.bskVariableList));
            this.currentVarList = this.editorService.setValueForUpdate(wVarList);
            if (this.enterVariable === false) {
                this.updateDocAddList(this.currentVarList);
            }
            const wFormData = new FormData();
            wFormData.append('DocumentList', JSON.stringify(this.addFileService.getDocumentList()));
            wFormData.append('Document', JSON.stringify(this.addFileService.getDocument(wFileName, this.blobPdf.size, this.baseRoot, this.storagePath)));
            wFormData.append('Variable', this.addFileService.prepareVarList(this.currentVarList, this.editorService));
            wFormData.append('BasketEngine', JSON.stringify(this.addFileService.getRequestSend(this.currentInfosMail, this.bsk.bskType, this.bsk.bskName)));
            wFormData.append('priority', this.priority);
            if (this.usePreProcess === true) {
                wFormData.append('PreProcess', JSON.stringify(this.addFileService.getPreProcess(this.preProcessName, this.parameterList)));
            }
            wFormData.append('file', this.blobPdf, this.modeleInfo.documentName);            
            wRes = await lastValueFrom(this.api.execUrlAction(this.getServer(), wFormData)); 
            this.close();
            this._messageService.addSuccess(this.translate.instant('Send_OK'));             
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant("Work_KO"));
            this.close();
        }
    }

    private getServer() {
        if (this.usePreProcess) {
            return 'senddocumentcollect';
        } else {
            return 'senddocument';
        }
    }

    private updateDocAddList(aCurrentVarList) {
        aCurrentVarList.forEach((item) => {
            this.addFileService.updateItem(item, this.editorService);
        });
    }
}